/**
 * Implementación simplificada del algoritmo UUID v4.
 * Generador de UUID basado en Math.random() para usar dentro del bundle
 * sin depender de la biblioteca externa.
 */
export function generateUUID(): string {
  // Utilizar la seguridad criptográfica cuando esté disponible
  if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
    return '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, (c) => {
      const n = parseInt(c, 10);
      return (n ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (n / 4)))).toString(16);
    });
  }
  
  // Fallback a Math.random() si crypto no está disponible
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
} 